// @flow
import * as React from 'react';
import { withRouter } from "react-router-dom";
import styled from 'styled-components';
import { connect } from "react-redux";
import _, { get } from 'lodash';
import type { TRootStore, TPlayersById } from "../../../modules/types";
import * as selectors from "../../../modules/selectors";
import * as actions from "../../../modules/actions";
import withRoundsSelector from "../../../components/utils/withRoundsSelector";
import { ButtonSecondaryLink } from '../../../components/ButtonSecondary';
import TransactionHistoryFilters from './transactionHistory/transactionHistoryFilters';
import TransactionHistoryRFARow from './transactionHistory/transactionHistoryRFARow';
type Props = {
	transactionHistory: typeof actions.leagueDraft.fetchTransactionHistory,
	showTeamsDraftLeague: typeof actions.leagueDraft.showTeamsDraftLeague,
	league_id: number,
	rounds_ordered: Array<Object>,
	teams_by_id: Object,
	players_by_id: TPlayersById,
	selected_round_id: number,
	setSelectedRoundId: Function,
	league: Object,
	transaction_history_with_player_names: Array<Object>,
}

type State = {
	selected_round_id: number,
	selected_owner: number,
	selected_transaction_type: string,
	selected_player: string,
}

const MessageText = styled.h4`
	font-size: 15px;
	line-height: 1.5;
	font-weight: bold;
	text-align: center;
	color: #777777;
	margin-bottom: 20px;
`;

const Wrapper = styled.div`
	background: white;
	padding: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;
export class TransactionHistoryPage extends React.Component<Props, State> {
	static defaultProps = {
		selected_round_id: 0 //'All'
	};
	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'getTransactionRow',
			'setSelectedRoundId',
			'setSelectedOwner',
			'setSelectedTransactionType',
			'setPlayerSearch',
			'onSearchSubmit',
		]);
	}

	state = {
		selected_round_id: 0,
		selected_owner: 0,
		selected_transaction_type: "",
		selected_player: ""
	}

	componentDidMount() {
		const {
			transactionHistory,
			showTeamsDraftLeague,
			league_id
		} = this.props;

		transactionHistory({
			league_id
		});
		showTeamsDraftLeague({
			league_id: league_id
		});
	}
	componentDidUpdate(prev_props: Props, prev_state: State) {
		const {
			transactionHistory,
			league_id,
		} = this.props;
		const { selected_round_id, selected_owner } = this.state;

		let data = { league_id };
		if (prev_state !== this.state) {

			if(selected_round_id === 0) {
				transactionHistory({
					...data,
					team_id: selected_owner,

				});
			}
			else {
				transactionHistory({
					...data,
					round_id: selected_round_id,
					team_id: selected_owner,
				});
			}
		}
	}


	get get_transaction_list() {
		const {
			transaction_history_with_player_names,
			league_id
		} = this.props;

		const {
			selected_round_id,
			selected_owner,
			selected_transaction_type,
			selected_player,
		} = this.state;

		if (!selected_round_id && !selected_owner
			&& !selected_transaction_type && _.isEmpty(transaction_history_with_player_names)) {
			return (
				<Wrapper>
					<MessageText>Your League Has No Transactions</MessageText>
					<ButtonSecondaryLink to={`/league/${league_id}/`}>
						Go to your League Overview
					</ButtonSecondaryLink>
				</Wrapper>
			);
		}

		const filteredTransactions = transaction_history_with_player_names
			? transaction_history_with_player_names
				.filter(transaction => transaction.player_name
					.includes(selected_player.toLowerCase())) : [];

		if (_.isEmpty(filteredTransactions)) {
			return (
				<Wrapper>
					<MessageText>Transaction wasn't found by your search criteria.</MessageText>
				</Wrapper>
			);
		}
		return this.getFilteredByType(filteredTransactions);

	}

	getFilteredByType(FilteredTransactions: Array<Object>) {
		const {
			selected_transaction_type
		} = this.state;

		if (selected_transaction_type === 'free_agent') {
			return this.getTransactionRow(FilteredTransactions
				.filter(trans => trans.type !== 'Trade'));
		}
		else if (selected_transaction_type === 'trade') {
			return this.getTransactionRow(FilteredTransactions
				.filter(trans => trans.type === 'Trade'));
		}

		return this.getTransactionRow(FilteredTransactions);
	}


	getTransactionRow(trade: Array<Object>) {
		const {
			players_by_id,
		} = this.props;

		// Order should be preserved for RFAs made at the same exact time
		const tradesWithOrder = _.map(trade, (value, i) => ({ ...value, order: i }));

		const transactionsRFAs = _.filter(
			tradesWithOrder,
			trans => trans.external_id !== 0
				&& trans.from !== 'Trade' && trans.to !== 'Trade'
		);

		const transactionsTradesAndFAs = _.filter(
			tradesWithOrder,
			trans => trans.external_id === 0
				|| trans.from === 'Trade' || trans.to === 'Trade'
		);


		const pairedRFAs = _(transactionsRFAs)
			.groupBy(x => x.external_id)
			.map((value, key) => ({ value }))
			.value();

		const pairedTradeAndFAs = _(transactionsTradesAndFAs)
			.groupBy(x => x.date_iso)
			.map((value, key) => ({ value }))
			.value();

		const transactionsJoinedTogether = pairedRFAs.concat(pairedTradeAndFAs);


		// Sort first by date
		// If date matches, refer to the original order
		// $FlowFixMe - Order By breaks flow for some reason
		const transactionsSortedByDate = _.orderBy(
			transactionsJoinedTogether,
			[
				'value.0.date_iso',
				'value.0.order'
			],
			[ 'desc', 'asc' ]
		);

		return (
			<TransactionHistoryRFARow
				players_by_id={players_by_id}
				trade={transactionsSortedByDate}
				key={1}
			/>
		);
	}

	get league_rounds() {
		const {
			rounds_ordered,
			league
		} = this.props;

		if (rounds_ordered && league && league.start_round && league.end_round) {
			return rounds_ordered.filter(round =>
				round.id >= league.start_round && round.id <= league.end_round
			);
		}

		return rounds_ordered;
	}

	setSelectedRoundId({ currentTarget }: Object) {
		const { value } = currentTarget;
		this.setState({ selected_round_id: parseInt(value, 10) });
	}

	setSelectedOwner({ currentTarget }: Object) {
		const { value } = currentTarget;
		this.setState({ selected_owner: parseInt(value, 10) });
	}

	setSelectedTransactionType({ currentTarget }: Object) {
		const { value } = currentTarget;
		this.setState({ selected_transaction_type: value });
	}

	setPlayerSearch(event: any) {
		const { value } = event.target;
		this.setState({ selected_player: value });
	}

	onSearchSubmit(event: any) {
		event.preventDefault();
	}

	render() {
		const { selected_round_id, teams_by_id } = this.props;
		return (
			<React.Fragment>
				<TransactionHistoryFilters
					selected={selected_round_id}
					rounds={this.league_rounds}
					teams={teams_by_id}
					handleRoundChange={this.setSelectedRoundId}
					handleOwnerChange={this.setSelectedOwner}
					handleTransactionChange={this.setSelectedTransactionType}
					handlePlayerChange={this.setPlayerSearch}
					handleSubmit={this.onSearchSubmit}
				/>

				{this.get_transaction_list}

			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: TRootStore, props) => {
	const actual_round = selectors.rounds.getActualRound(state);
	const actual_round_id = get(actual_round, 'id', 0);
	const league = selectors.leagueDraft.getLeague(state, props);
	const { start_round, last_round } = league;
	let last_round_id = actual_round_id < last_round ? last_round : actual_round_id;
	const rounds = selectors.rounds.getRounds(state);
	const league_rounds = rounds.filter(({ id }) => _.inRange(id, start_round, last_round_id + 1));


	return {
		league_rounds: _.filter(league_rounds, ({ id }) => id <= actual_round_id),
		players_by_id: selectors.players.getExtendedPlayersById(state),
		teams_by_id: state.leagues.teams_by_id,
		transaction_history_with_player_names: selectors.getTransactionPlayerNames(state),
	};
};
const mapDispatchToProps = {
	transactionHistory: actions.leagueDraft.fetchTransactionHistory,
	showTeamsDraftLeague: actions.leagueDraft.showTeamsDraftLeague,
};


const TransactionHistory = withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(withRoundsSelector(TransactionHistoryPage)));

export default TransactionHistory;


// WEBPACK FOOTER //
// ./src/pages/league/transactions/transactionHistory.js